import { Skeleton } from '@immo/ui-kit';
import { useTranslations } from '@/i18n/use-translations';

/**
 * Hydration-fallback page rendered by React Router v7 while a route's
 * loader resolves on the first page load. Used by every route that does
 * an authenticated round-trip (`requireSession` calling `/auth/me`) so
 * the SPA paints something deterministic instead of blank-screening
 * until the network call returns.
 */
export function LoadingPage() {
  const t = useTranslations('pages');

  return (
    <main
      role="status"
      aria-label={t('loading')}
      className="flex min-h-screen items-center justify-center bg-canvas p-6"
    >
      <div className="w-full max-w-md space-y-3">
        <Skeleton className="h-6 w-1/2" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
        <Skeleton className="h-4 w-4/6" />
      </div>
    </main>
  );
}
